module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-cove-fluted-hamilton-0.e81fe227.jpg";